// Prefer the searchable bank/branch name captured by BankBranchSelect; fall back
// to the raw number for cheque records created before that feature existed.
export const bankLabel = (cheque) => cheque?.bank_name || cheque?.bank_number || '';
export const branchLabel = (cheque) => cheque?.branch_name || cheque?.branch_number || '';
